import { json, type LoaderFunction } from '@remix-run/node'

export let loader: LoaderFunction = async ({ request }): Promise<{}> => {
	return json({})
}

export default function HomeschoolingRoute() {
	return (
		<>
			<h1 className="pb-4 text-center font-serif text-2xl uppercase tracking-widest">
				Publications
			</h1>
			<div className="flex flex-col space-y-4">
				<div>
					<h2 className="mb-1 text-lg font-bold">Poetry</h2>
					<ul className="ml-4">
						<li className="ml-4 -indent-4">
						“Spilled Milk” forthcoming in Anglican Theological Review
						</li>
						<li className="ml-4 -indent-4">
							<a className="special" href="https://www.ekstasismagazine.com/poetry/2024/memento-vivere">
							“Memento Vivere” in Ekstasis Magazine
							</a>
						</li>
						<li className="ml-4 -indent-4">
							“Settled” in{' '}
							<i>
								Homage to Søren Kierkegaard: An Anthology in Honor of Rev.
								Ronald F. Marshall
							</i>{' '}
							(Wiseblood Books)
						</li>
						<li className="ml-4 -indent-4">
							“In Defense of Spring” in Joie de Vivre (Spring 2023)
						</li>
						<li className="ml-4 -indent-4">
							<a
								className="special"
								href="https://www.jdvjournal.com/archive/aftertherain"
							>
								“After the Rain”
							</a>{' '}
							in Joie de Vivre (Feb. 2023)
						</li>
						<li className="ml-4 -indent-4">
							<a
								className="special"
								href="https://www.thesunlightpress.com/2023/01/24/evening-walk-with-jacob/"
							>
								“Evening Walk with Jacob”
							</a>{' '}
							in Sunlight Press (Jan. 2023)
						</li>
						<li className="ml-4 -indent-4">
							“After the Rain” in CLA Newsletter (Nov. 2022)
						</li>
						<li className="ml-4 -indent-4">
							“Milkweed” in Channel (Autumn 2020)
						</li>
					</ul>
				</div>

				<div>
					<h2 className="mb-1 text-lg font-bold">Fiction</h2>
					<ul className="ml-4">
						<li className="ml-4 -indent-4">
						“Hildegard’s Garden” in Joie de Vivre (Spring 2024)
						</li>
					</ul>
				</div>
				
				<div>
					<h2 className="mb-1 text-lg font-bold">Essays</h2>
					<ul className="ml-4">
						<li className="ml-4 -indent-4">
							<a className="special" href="https://www.americamagazine.org/arts-culture/2024/08/30/tomie-depaola-illustrator-248591">
							Tomie dePaola and Catholic children’s literature: Who will be the next great author and illustrator?
								</a>{' '}in America Magazine (August 2024)
						</li>
						<li className="ml-4 -indent-4">
							<a className="special" href="https://www.frontporchrepublic.com/2023/08/in-defense-of-playdates/">
								"In Defense of Playdates"
							</a>{' '}in Front Porch Republic (August 2023)
						</li>
						<li className="ml-4 -indent-4">
							<a className="special" href="https://www.grottonetwork.com/stories/reflective-narrative-about-gardening-as-hobby">
							Gardening: A Practice of Patience, a Place of Connection
							</a>{' '}on The Grotto Network (May 2023)
						</li>
						<li className="ml-4 -indent-4">
							<a
								className="special"
								href="https://www.stonecropreview.com/issues/issue-5-flora/"
							>
								“Kumquats and Cedar Waxwings”
							</a>{' '}
							in Stonecrop (Issue 5)
						</li>
						<li className="ml-4 -indent-4">
							<a
								className="special"
								href="https://www.dappledthings.org/deep-down-things/reading-crime-and-punishment-with-dorothy-day"
							>
								“Reading Crime and Punishment with Dorothy Day”
							</a>{' '}
							on Deep Down Things (April 2022)
						</li>
						<li className="ml-4 -indent-4">
							Essays in the anthology{' '}
							<a
								className="special"
								href="https://parkendbooks.com/shop/darkness-is-as-light/"
							>
								Darkness Is as Light
							</a>{' '}
							(Park End Books, 2021)
						</li>
					</ul>
				</div>

				<div>
					<h2 className="mb-1 text-lg font-bold">Instructionals</h2>
					<ul className="ml-4">
						<li className="ml-4 -indent-4">
							“Visible Mending for Style and Sustainability” in Geez (Winter
							2023)
						</li>
					</ul>
				</div>
			</div>
		</>
	)
}
